import React, { Component } from 'react';
import './ScrollToTop.scss';
/* eslint-disable */

class ScrollToTop extends React.Component {
  constructor() {
    super();
    this.state = {
      intervalId: 0, scrollStepInPx: "50", delayInMs: "16.66", resized: false
    };
  }
  scrollStep() {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.state.scrollStepInPx);
    if(window.scrollY==0) {
      $('#skipMainContent_ADA').focus();  
    }
  }
  scrollToTop() {
    let intervalId = setInterval(this.scrollStep.bind(this), this.state.delayInMs);
    this.setState({
      intervalId: intervalId
    });
    if ($('#ccl-refresh-header')) {
      $('#ccl-refresh-header .header-branding .logo').focus();
      $('#ccl-refresh-header .header-branding .logo').css('focus', '3px solid red !important');
    } else {
      $('.top-nav .nav-left .logo').focus();
      $('.top-nav .nav-left .logo').css('focus', '3px solid red !important');
    }
  }

  componentDidMount() {
    $(window).resize(() => {
      this.setState({ resized: true })
    });
  }

  render() {
    let element = null;
    if (window.innerWidth <= 800) {
      element =
        <a href="javascript:;" aria-label="click on this back to top button to go to begining of the page" role="button">
          <img className="scroll" src="/_ui/responsive/ccl/assets/icons/scroll-arrow-to-up.svg"
            alt="" onClick={() => { this.scrollToTop(); }} />
        </a>
    } else {
      element = <a href="javascript:;" className="btn btn-outline-black back-to-top-btn"
        aria-label="click on this back to top button to go to begining of the page"
        role="button" onClick={() => { this.scrollToTop(); }}>
        <span className="back-to-top-text">Back to Top</span>
        <img className="scroll" src="/_ui/responsive/ccl/assets/icons/scroll-arrow-to-up.svg"
          alt="Top Arrow" />
      </a>
    }
    return element;
  }
}

export default ScrollToTop;


// WEBPACK FOOTER //
// ./reactComponents/components/scrollToTop/ScrollToTop.jsx